import { useState } from 'react';
import CustomMargin from "../../../components/custom-margin";
import axios from 'axios';
import AlertComponent from '../../../components/alert-component';
import { PROXY } from '../../../components/constants'

export default function SubmitTestimonial() {
    const [values, setValues] = useState({
        title: '',
        details: ''
    });
    const [hideFeedback, setHideFeedback] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        axios.post(`${PROXY}/submit_feedback`, values)
            .then(res => {
                setAlertMessage('Feedback Submitted Successfully!');
                setHideFeedback(true);
            })
            .catch(err => {
                console.error(err);
                setAlertMessage('Failed to submit feedback.');
            });
    };

    return (
        <CustomMargin className="px-5 pb-10 lg:px-10">
            <form onSubmit={handleSubmit}>
                <div className={`flex w-full flex-col rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0c0c0c] p-7 shadow-xl shadow-black/20 sm:w-full lg:w-1/2 ${hideFeedback ? 'hidden' : ''}`}>
                    <h2 className="font-fontMontserrat text-4xl text-zinc-100">We Value Your Feedback!</h2>
                    <p className="mt-5 leading-7 text-zinc-400">Your feedback is incredibly important to us. Please rest assured that all feedback provided is completely anonymous and safe. Your honest opinions help us improve and serve you better.</p>
                    <input
                        placeholder="Title..."
                        className="mt-5 rounded-lg border border-zinc-700 bg-black/40 p-3 text-zinc-100 outline-none transition placeholder:text-zinc-600 focus:border-zinc-400"
                        onChange={(e) => setValues({ ...values, title: e.target.value })}
                        required
                    />
                    <textarea
                        placeholder="Share your feedback here..."
                        rows={5}
                        className="mt-5 rounded-lg border border-zinc-700 bg-black/40 p-3 text-zinc-100 outline-none transition placeholder:text-zinc-600 focus:border-zinc-400"
                        onChange={(e) => setValues({ ...values, details: e.target.value })}
                        required
                    >
                    </textarea>
                    <button
                        type="submit"
                        className="mt-5 rounded-xl border border-zinc-600 bg-gradient-to-b from-zinc-800 to-zinc-950 px-7 py-4 text-sm tracking-[0.14em] text-zinc-100 transition hover:border-zinc-300"
                    >
                        SUBMIT
                    </button>
                </div>
            </form>
            {hideFeedback && (
                <AlertComponent message={alertMessage} />
            )}
        </CustomMargin>
    );
}
